import { StoreModel } from "../store.model";

export const countryIdSelector = (state: StoreModel): string => state.masterDataDownload.countryId;

export const constructionTypeIdSelector = (state: StoreModel): string => state.masterDataDownload.constructionTypeId;

export const errorSelector = (state: StoreModel): any => state.masterDataDownload.error;

export const isLoadingSelector = (state: StoreModel): boolean => state.masterDataDownload.isLoading;
